import { Flex, type FlexProps } from '@/ui';
import { Navigation } from './Navigation';

export const Sidebar = (props: FlexProps) => {
  return (
    <Flex
      bg="gray.100"
      borderBottomLeftRadius="20"
      borderRightColor="gray.200"
      borderRightWidth="1px"
      borderTopLeftRadius="20"
      direction="column"
      gap="1"
      // The accounts list grows with membership count, and names wrap to two
      // lines — scroll here rather than let ModalContent's overflow="hidden"
      // clip the tabs and Sign out below it.
      overflowY="auto"
      pb="2"
      pt="8"
      px="3"
      w="280px"
      {...props}
    >
      <Navigation />
    </Flex>
  );
};
